<template>
  <gj-modal
      v-bind="$attrs"
      v-on="$listeners"
      :visible.sync="modalVisible"
      :no-padding="true"
      @open="modalOpen"
      @cancel="cancel"
      :contentStyle="{'height': '100%'}"
      @confirm="confirm">
    <template #header>
      <span>添加商品</span>
    </template>
    <template #content>
      <app-base-main
          parent-table
          :table-shadow="false">
        <template #filter-group>
          <app-filter-group
              :reset="false"
              @query="$gjNoticeQuery"
              @reset="$gjReset">
            <gj-select-input
                v-model="keyword"
                :options="[
                  {id: 'msku', text: 'MSKU'},
                  {id: 'fnsku', text: 'FNSKU'},
                  {id: 'asin', text: 'ASIN'},
                  {id: 'sku', text: 'SKU'},
                  {id: 'skuName', text: '产品名称'},
                ]"
                :width="['100px', '150px']"
            ></gj-select-input>
          </app-filter-group>
        </template>
        <template #table>
          <gj-table
              ref="gjTable"
              name="addFbaShipmentProductAddModal"
              :index="false"
              :loading="loading"
              :data="tableData"
              :columns="columns"
              :show-overflow="false"
              :offset-height="62"
              adapt-parent
              selection
              :pagination="pagination"
              @sort-change="$gjSortChange"
              @page-change="$gjNoticeQuery">
            <template v-slot:sku="{row}">
              <div>{{row.sku | defaultShow}}</div>
              <div>
                <gj-tooltip
                    :text-line="1"
                    :content="row.skuName">
                  {{row.skuName | defaultShow}}
                </gj-tooltip>
              </div>
            </template>
            <template v-slot:msku="{row}">
              <div>{{row.msku | defaultShow}}</div>
              <div>{{row.fnsku | defaultShow}}</div>
              <div>{{row.asin | defaultShow}}</div>
            </template>
          </gj-table>
        </template>
      </app-base-main>
    </template>
  </gj-modal>
</template>

<script>
  import {modalMixIn, queryMixin, selectionMixin} from "@/minxins";
  import {getShipmentProductPage} from "@/api/logistics";
  import {defaultVal, isMeaningful} from "@/utils/common";

  export default {
    name: "app-add-product-modal",
    mixins: [modalMixIn, queryMixin, selectionMixin],
    props: {
      warehouseId: {
        required: true,
      },
      countryCode: {
        required: true,
      },
      hideMskuList: {
        required: true
      }
    },
    data() {
      return {
        tableData: [],
        columns: [
          {id: 'picture', header: '图片', field: 'picture:skuImageUrl', width: '50px'},
          {id: 'sku', header: 'SKU/产品名称', field: 'slot:sku', minWidth: '200px'},
          {id: 'msku', header: 'MSKU/FNSKU/ASIN', field: 'slot:msku', minWidth: '150px'},
          {id: 'fulfillableQuantity', header: '可售', field: 'fulfillableQuantity', minWidth: '70px', align: 'right'},
          {id: 'reservedQuantity', header: '预留', field: 'reservedQuantity', minWidth: '70px', align: 'right'},
          {id: 'workingQuantity', header: 'Working', field: 'workingQuantity', minWidth: '70px', align: 'right'},
          {id: 'shippedQuantity', header: 'Shipped', field: 'shippedQuantity', minWidth: '70px', align: 'right'},
          {id: 'receivingQuantity', header: 'Receiving', field: 'receivingQuantity', minWidth: '70px', align: 'right'},
        ],
        keyword: {
          key: 'msku',
          value: null
        }
      }
    },
    created() {
      this.sort.prop = 'msku';
    },
    methods: {
      $gjQuery() {
        // 构造查询参数
        const params = {
          model: {
            warehouseId: this.warehouseId,
            countryCode: this.countryCode,
            hideMskuList: this.hideMskuList,
          },
          ...this.queryPagination,
          ...this.querySort
        };
        params.model[this.keyword.key] = defaultVal(this.keyword.value, null);
        // 查询
        this.loading = true;
        getShipmentProductPage(params)
          .then((data) => {
            if (isMeaningful(data)) {
              this.tableData = data.records;
              this.pagination = this.getPagination(data);
            } else {
              this.tableData = [];
            }
          })
          .complete(() => {
            this.loading = false;
          });
      },
      confirm() {
        if (this.selectedRows.length === 0) {
          this.$gjMessage.error('请勾选产品');
          return;
        }
        this.$emit('select', this.selectedRows);
        this.$gjDestroy();
      }
    }
  }
</script>

<style lang="scss" scoped>
  .add-product-btn {
    margin: 5px 0 10px;
  }
  /deep/ .base-main{
    height: 100%;
    box-sizing: border-box;
  }
</style>
